import { get, post } from './'
import _ from 'lodash'
import {
  showPrimaryDiamondPanel,
  jewelryTypeIsRing,
  hideProngNumber,
  hideBasketStyle,
  hideCathedralShoulders,
  showProngPanel,
  showAdditionalDiamondPanel,
  showAdditionalOptionPanel,
  showStockItemPanel,
  showPrimaryMetalTypePanel
} from '../utils/jewelry-validation'

export const getPrimaryDiamondAttributes = ({shapes, colour, primary_diamond_size}) => {
  return {
    shape: shapes[0] ? shapes[0].replace('round', 'round_shape') : shapes[0],
    color: colour,
    weight_in_ct: primary_diamond_size,
    is_certified: true
  }
}

export const getProngAttributes = (filters) => {
  let attributes = {
    style: filters.prong_style
  }
  if (!hideProngNumber(filters)) {
    attributes.num_of_prongs = filters.prong_number
  }
  if (!hideBasketStyle(filters)) {
    attributes.basket_style = filters.basket_style
  }
  if (!hideCathedralShoulders(filters)) {
    // cathedral_shoulders: 'no' or 'half_diamond' are translated to be 'false'
    attributes.has_cathedral_shoulder = filters.cathedral_shoulders === 'yes'
  }
  return attributes
}

export const getPrimaryDiamondHaloAttributes = (filters) => {
  const primaryDiamondHaloWidth = filters.central_halo_width === 'custom' ? parseFloat(filters.central_halo_custom_width) : parseFloat(filters.central_halo_width)
  return {
    style: filters.central_halo_style,
    shape: 'round_shape',
    width_in_mm: primaryDiamondHaloWidth,
    quality: filters.central_halo_quality,
    setting_style: filters.central_halo_setting_style,
    milgrain: filters.central_halo_milgrain
  }
}

export const getHaloSideDiamondAttributes = (filters) => {
  return {
    shape: 'round_shape',
    quality: filters.quality_of_diamonds_on_outside_of_halo,
    setting_style: filters.setting_style_of_diamonds_on_outside_of_halo,
    milgrain: filters.milgrain_on_outside_of_halo
  }
}

export const getShankTopDiamondAttributes = (filters) => {
  var rowsOfDiamonds

  const rowValues = {
    single_row: 1,
    two_rows: 2,
    three_rows: 3,
    four_rows: 4
  }

  const allValues = {
    single_row: 1,
    split_rows: 2,
    intertwined_rows: 2,
    double_rows: 2,
    three_rows: 3,
    four_rows: 4,
    five_rows: 5
  }

  if (filters.diamonds_down_top_of_shank !== 'all') {
    rowsOfDiamonds = rowValues[filters.diamonds_down_top_of_shank]
  } else {
    // The value of "all" is different depending on the selected shank type/layout
    rowsOfDiamonds = allValues[filters.shank_type]
  }

  return {
    rows_of_diamond: rowsOfDiamonds,
    shape: filters.shape_of_diamonds_down_top_of_shank.replace('round', 'round_shape'),
    distance_percentage: filters.distance_diamonds_down_top_of_shank,
    quality: filters.quality_of_diamonds_down_top_of_shank,
    setting_style: filters.setting_style_of_diamonds_down_top_of_shank,
    milgrain: filters.milgrain_top_of_shank
  }
}

export const getShankSideDiamondAttributes = (filters) => {
  return {
    distance_percentage: filters.distance_diamonds_down_sides_of_shank,
    quality: filters.quality_of_diamonds_down_sides_of_shank,
    shape: 'round_shape',
    setting_style: filters.setting_style_of_diamonds_down_sides_of_shank,
    milgrain: filters.milgrain_sides_of_shank
  }
}

export const getMultiStoneAttributes = ({multi_stone_setting, multi_stone_quality, small_diamond_id}) => {
  return {
    setting: multi_stone_setting,
    quality: multi_stone_quality,
    small_diamond_id: small_diamond_id.value
  }
}

export const getMultiStoneHaloAttributes = (filters) => {
  const sideStoneHaloWidth = filters.side_stone_halo_width === 'custom' ? filters.side_stone_halo_custom_width : parseFloat(filters.side_stone_halo_width)
  return {
    shape: 'round_shape',
    quality: filters.side_stone_halo_quality,
    style: filters.side_stone_halo_style,
    overlapping_setting: filters.side_stone_overlapping_setting,
    width_in_mm: sideStoneHaloWidth,
    setting_style: filters.side_stone_halo_setting_style,
    milgrain: filters.side_stone_halo_milgrain
  }
}

export const getShankAttributes = (filters) => {
  const verticalShankThickness = filters.vertical_shank_thickness === 'custom' ? parseFloat(filters.custom_vertical_shank_thickness) : parseFloat(filters.vertical_shank_thickness)
  const straightShankWidth = filters.shank_straight_width === 'custom' ? parseFloat(filters.shank_straight_custom_width) : parseFloat(filters.shank_straight_width)
  return {
    row_layout: filters.shank_type,
    shape: filters.shank_shape,
    vertical_thickness_in_mm: verticalShankThickness,
    straight_width_in_mm: straightShankWidth,
    tapered_min_width_in_mm: filters.shank_shape !== 'straight' && filters.shank_shape !== '' ? filters.shank_tapered_width[0] : '',
    tapered_max_width_in_mm: filters.shank_shape !== 'straight' && filters.shank_shape !== '' ? filters.shank_tapered_width[1] : ''
  }
}

export const getAdditionalDiamondAttributes = (filters) => {
  return _.values(filters.additional_diamonds).map((additionalDiamond) => {
    return {
      quantity: additionalDiamond.additional_diamond_quantity,
      quality: additionalDiamond.additional_diamond_quality,
      small_diamond_id: additionalDiamond.small_diamond_id.value,
      is_certified: false,
      additional_diamond_setting_style: additionalDiamond.additional_diamond_setting_style
    }
  })
}

export const getPendantChainAttributes = ({pendant_chain_length, pendant_chain_width, pendant_chain_metal_type}) => {
  return {
    length_enum: pendant_chain_length,
    width_enum: pendant_chain_width,
    metal_type_enum: pendant_chain_metal_type
  }
}

export const getBailDiamondAttributes = (filters) => {
  return {
    shape: filters.bail_diamond_shape,
    quality: filters.bail_diamond_quality,
    setting_style: filters.bail_diamond_setting_style,
    milgrain: filters.bail_diamond_milgrain
  }
}

export const getBailAttributes = (filters) => {
  const bailStraightWidth = filters.bail_type === 'straight' ? parseFloat(filters.bail_straight_width_in_mm) : ''
  const bailTaperedMinWidth = filters.bail_type === 'tapered' ? parseFloat(filters.bail_tapered_width_in_mm[0]) : ''
  const bailTaperedMaxWidth = filters.bail_type === 'tapered' ? parseFloat(filters.bail_tapered_width_in_mm[1]) : ''

  return {
    bail_type: filters.bail_type,
    length_in_mm: filters.bail_length_in_mm,
    straight_width_in_mm: bailStraightWidth,
    tapered_min_width_in_mm: bailTaperedMinWidth,
    tapered_max_width_in_mm: bailTaperedMaxWidth
  }
}

export const getStockItemAttributes = (filters) => {
  return {
    item_price: parseFloat(filters.item_price),
    item_price_currency: `item_price_is_in_${filters.item_price_currency}`,
    primary_diamond_qty: filters.primary_diamond_qty,
    item_description: filters.item_description
  }
}

export const parseCommonParams = ({jewelry_type, additional_price, additional_price_currency, additional_notes}) => {
  return {
    jewellery_type: jewelry_type,
    additional_price: parseFloat(additional_price) || 0,
    additional_price_currency: additional_price_currency || 'usd',
    additional_notes
  }
}

export const parsePrimaryMetalTypeParams = (filters) => {
  return showPrimaryMetalTypePanel(filters) ? {primary_metal_type: filters.primary_metal_type} : {}
}

export const parsePrimaryDiamondParams = (filters) => {
  var primaryDiamondParams = {}

  if (showPrimaryDiamondPanel(filters)) {
    primaryDiamondParams = _.merge(primaryDiamondParams, { primary_diamond_attributes: getPrimaryDiamondAttributes(filters) })

    // Primary Diamond Halo
    if (filters.has_central_halo) {
      primaryDiamondParams = _.merge(primaryDiamondParams, {primary_diamond_attributes: {primary_diamond_halo_attributes: getPrimaryDiamondHaloAttributes(filters)}})
    }

    // Halo Side Diamond
    if (filters.diamonds_on_outside_of_halo) {
      primaryDiamondParams = _.merge(primaryDiamondParams, {primary_diamond_attributes: {primary_diamond_halo_attributes: {halo_side_diamond_attributes: getHaloSideDiamondAttributes(filters)}}})
    }
  }

  return primaryDiamondParams
}

export const parseProngParams = (filters) => {
  var prongParams = {}

  if (showProngPanel(filters)) {
    prongParams = _.merge(prongParams, {prong_attributes: getProngAttributes(filters)})
  }

  return prongParams
}

export const parseRingParams = (filters) => {
  var ringParams = {}

  if (jewelryTypeIsRing(filters)) {
    // Ring Common Fields
    ringParams.ring_size = parseFloat(filters.ring_size)
    ringParams.shank_attributes = getShankAttributes(filters)

    // SHANK TOP DIAMOND
    if (filters.has_diamonds_down_top_of_shank) {
      ringParams = _.merge(ringParams, {shank_attributes: {shank_top_diamond_attributes: getShankTopDiamondAttributes(filters)}})
    }
    // SHANK SIDE DIAMOND
    if (filters.diamonds_on_outside_sides_of_shank) {
      ringParams = _.merge(ringParams, {shank_attributes: {shank_side_diamond_attributes: getShankSideDiamondAttributes(filters)}})
    }
    // Multi Stone
    if (filters.multi_stone_ring) {
      ringParams = _.merge(ringParams, {multi_stone_attributes: getMultiStoneAttributes(filters)})
      // Side Stone Halo
      if (filters.has_side_stone_halo) {
        // jewelleryParams.multi_stone_attributes.multi_stone_halo_attributes = getMultiStoneHaloAttributes(filters)
        ringParams = _.merge(ringParams, {multi_stone_attributes: {multi_stone_halo_attributes: getMultiStoneHaloAttributes(filters)}})
      }
    }
  }

  return ringParams
}

export const parsePendantParams = (filters) => {
  var pendantParams = {}

  if (filters.jewelry_type === 'Pendant') {
    pendantParams.basket_type = filters.basket_type
    // Pendant Chain
    if (filters.has_pendant_chain) {
      pendantParams = _.merge(pendantParams, {pendant_chain_attributes: getPendantChainAttributes(filters)})
    }
    // Bail
    if (filters.has_bail) {
      pendantParams = _.merge(pendantParams, {bail_attributes: getBailAttributes(filters)})
      // Bail Diamond
      if (filters.has_bail_diamond) {
        pendantParams = _.merge(pendantParams, {bail_attributes: {bail_diamond_attributes: getBailDiamondAttributes(filters)}})
      }
    }
  }

  return pendantParams
}

export const parseStudEarringParams = (filters) => {
  var studEarringParams = {}

  if (filters.jewelry_type === 'StudEarring') {
    studEarringParams.basket_type = filters.basket_type
  }

  return studEarringParams
}

export const parseAdditionalOptionParams = (filters) => {
  var additionalOptionParams = {}

  if (showAdditionalOptionPanel(filters)) {
    if (filters.additional_milgrain !== 'none') {
      additionalOptionParams.additional_milgrain = filters.additional_milgrain
    }

    if (filters.special_finish !== 'none') {
      additionalOptionParams.special_finish = filters.special_finish
    }

    if (filters.hand_engraving !== 'none') {
      additionalOptionParams.hand_engraving = filters.hand_engraving
    }
  }

  return additionalOptionParams
}

export const parseStockItemParams = (filters) => {
  return showStockItemPanel(filters) ? getStockItemAttributes(filters) : {}
}

export const parseAdditionalDiamondParams = (filters) => {
  var additionalDiamondParams = {}

  if (showAdditionalDiamondPanel(filters) && !_.isEmpty(filters.additional_diamonds)) {
    additionalDiamondParams = _.merge(additionalDiamondParams, {additional_diamonds_attributes: getAdditionalDiamondAttributes(filters)})
  } else {
    additionalDiamondParams = _.merge(additionalDiamondParams, {additional_diamonds_attributes: []})
  }

  return additionalDiamondParams
}

export function assembleJewelryParams (filters) {
  var jewelleryParams = {}

  // Common Attributes
  jewelleryParams = _.merge(jewelleryParams, jewelryApi.parseCommonParams(filters))

  // Primary Metal Type
  jewelleryParams = _.merge(jewelleryParams, jewelryApi.parsePrimaryMetalTypeParams(filters))

  // Primary Diamond
  jewelleryParams = _.merge(jewelleryParams, jewelryApi.parsePrimaryDiamondParams(filters))

  // Prong
  jewelleryParams = _.merge(jewelleryParams, jewelryApi.parseProngParams(filters))

  // Ring Type Jewelry
  jewelleryParams = _.merge(jewelleryParams, jewelryApi.parseRingParams(filters))

  // Pendant
  jewelleryParams = _.merge(jewelleryParams, jewelryApi.parsePendantParams(filters))

  // Stud Earring
  jewelleryParams = _.merge(jewelleryParams, jewelryApi.parseStudEarringParams(filters))

  // Optional Common Jewelry Properties
  jewelleryParams = _.merge(jewelleryParams, jewelryApi.parseAdditionalOptionParams(filters))

  // Stock Item
  jewelleryParams = _.merge(jewelleryParams, jewelryApi.parseStockItemParams(filters))

  // Additional Diamond(s)
  jewelleryParams = _.merge(jewelleryParams, jewelryApi.parseAdditionalDiamondParams(filters))

  return jewelleryParams
}

export function jewelrySearch (filters) {
  return post('/jewellery', assembleJewelryParams(filters))
}

export function getSmallDiamondsByShapeAndQuality (shape, quality) {
  return get('/small_diamonds', {params: {shape, quality}})
}

export function getVerticalShankThicknesses () {
  return get('/vertical_shank_thickness')
}

export function getDefaultShankWidths () {
  return get('/default_shank_width')
}

export function getDefaultHaloWidths () {
  return get('/default_halo_width')
}

export const jewelryApi = {
  getPrimaryDiamondAttributes,
  getProngAttributes,
  getPrimaryDiamondHaloAttributes,
  getHaloSideDiamondAttributes,
  getShankTopDiamondAttributes,
  getShankSideDiamondAttributes,
  getMultiStoneAttributes,
  getMultiStoneHaloAttributes,
  getShankAttributes,
  getAdditionalDiamondAttributes,
  getPendantChainAttributes,
  getBailDiamondAttributes,
  getBailAttributes,
  getStockItemAttributes,
  parseCommonParams,
  parsePrimaryMetalTypeParams,
  parsePrimaryDiamondParams,
  parseProngParams,
  parseRingParams,
  parsePendantParams,
  parseStudEarringParams,
  parseAdditionalOptionParams,
  parseStockItemParams,
  parseAdditionalDiamondParams,
  assembleJewelryParams,
  jewelrySearch,
  getSmallDiamondsByShapeAndQuality,
  getVerticalShankThicknesses,
  getDefaultShankWidths,
  getDefaultHaloWidths
}



// WEBPACK FOOTER //
// ./src/api/jewelry.js